<script>
export default {
  components: {},
  props: {
    menuItemList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  created() {},
  data: function() {
    return {
      selected: 0,
      activeClass: "",
      empty: "",
      reportList: [],
      reportRoute: "/Report/"
    };
  }
};
</script>

<template>
  <ul class="submenu">
    
    <li class="has-submenu" v-for="item in this.menuItemList" :key="item.id">
      <a href="#">
        <i class="ri-arrow-right-s-line"></i>
        {{ item.label }}</a
      >
      <ul class="submenu">
        <li v-for="itemc in item.children" :key="itemc.id">
          <a
            v-if="itemc.KeyApi == null"
            :href="'/ReportPro/' + itemc.reportId"
            >{{ itemc.label }}</a
          >
          <a
            v-else-if="itemc.KeyApi == 'link'"
            :href="itemc.url"
            target="_blank"
            >{{ itemc.label }}</a
          >
          <a
            v-else
            :href="'/Report/' + itemc.KeyApi + '/' + itemc.workSpaceApiKey"
            >{{ itemc.label }}
          </a>
        </li>
      </ul>
    </li>
  </ul>
  <!-- end navbar-custom -->
</template>

;
